import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, urlBackend } from "@/shared";
import { ITipoCuentaBancaria } from "@/shared/interfaces";
import { useQuery } from "@tanstack/react-query";

export type GetTypeCountParams = {
  page?: number;
  nombre?: string;
  page_size?: number;
}

const { get } = erpApi();


export const useFetchTipoCuentaBancario = (params?: GetTypeCountParams) => {
  return useQuery({
    queryKey: ['tipos-cuenta-bancaria', ...Object.values(params || {})],
    queryFn: async () => {
      return getTipoCuentaBancario(params);
    }
  });
};

export const getTipoCuentaBancario = async (params?: GetTypeCountParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  return get<ITipoCuentaBancaria>(
    `${urlBackend}api/v1/tipos-cuenta-bancaria/?${queryParams}`,
    true
  );
};